'use es6';

import Client from 'AdsUI/data/Client';
const API_BASE = `ads/v1/leadSync`;
export const getAvailableLeadSyncingEntities = network => {
  return Client.apiRequest(`${API_BASE}/${network.toLowerCase()}/available`, {
    timeout: 60000
  });
};
export const selectLeadSyncingEntities = (network, networkUserId, selections) => {
  return Client.apiRequest(`${API_BASE}/${network.toLowerCase()}/subscribe/bulk`, {
    type: 'PUT',
    query: {
      networkUserId
    },
    data: selections
  });
};
export const getSelectedLeadSyncingEntities = () => {
  return Client.apiRequest(`${API_BASE}/selected`);
};
export const getLeadSyncErrorAlert = () => {
  return Client.apiRequest(`${API_BASE}/error-alert/show`);
};
export const deleteLeadSyncErrorAlert = () => {
  return Client.apiRequest(`${API_BASE}/error-alert`, {
    type: 'DELETE'
  });
};
export const fetchNotificationEmails = (network, leadSyncingEntityId, formId) => {
  return Client.apiRequest(`${API_BASE}/${network.toLowerCase()}/entity/${leadSyncingEntityId}/form/${formId}/notification-emails`);
};
export const updateNotificationEmails = (network, leadSyncingEntityId, formId, notificationEmails) => {
  return Client.apiRequest(`${API_BASE}/${network.toLowerCase()}/entity/${leadSyncingEntityId}/form/${formId}/notification-emails`, {
    type: 'PUT',
    query: {
      notificationEmails
    }
  });
};
export const createWorkflow = (network, leadSyncingEntityId, formId, name) => {
  return Client.apiRequest(`${API_BASE}/${network.toLowerCase()}/entity/${leadSyncingEntityId}/form/${formId}/workflow`, {
    type: 'POST',
    query: {
      name
    }
  });
};
export const createList = (network, leadSyncingEntityId, formId, name) => {
  return Client.apiRequest(`${API_BASE}/${network.toLowerCase()}/entity/${leadSyncingEntityId}/form/${formId}/smart-list`, {
    type: 'POST',
    query: {
      name
    }
  });
};
export const getLeadsCount = (network, networkUserId, leadSyncingEntityId) => {
  return Client.apiRequest(`${API_BASE}/${network.toLowerCase()}/entity/${leadSyncingEntityId}/leadsCount`, {
    query: {
      networkUserId
    }
  });
};